export const akhmetova = {
    id: "akhmetova",
    name: { ru: "Ахметова Гульнара Умурзаковна", kz: "Ахметова Гүлнара Умурзақызы" },
    position: { ru: "Врач-оториноларинголог высшей категории", kz: "Жоғары санатты дәрігер-оториноларинголог" },
    department: "specialists",
    image: "/team_photoes/new/akhmetova.png",
    experience: {
      ru: "35 лет",
      kz: "35 жыл"
    },
    education: {
      ru: "Целиноградский государственный медицинский институт",
      kz: "Целиноград мемлекеттік медициналық институты"
    },
    specialization: {
      ru: `• Актуальные вопросы болезней уха, горла и носа
• Аудиология и сурдология
• Травмы, заболевания, инородные тела ЛОР-органов и неотложная помощь
• Функциональная эндоскопическая риносинусохирургия
• Военно-врачебная (врачебно-летная) экспертиза
• Тактика оказания неотложной помощи детям и взрослым
• Скорая и неотложная медицинская помощь`,
      kz: `• Құлақ, тамақ, мұрын ауруларының өзекті мәселелері
• Аудиология және сурдология
• ЛОР-ағзаларының жарақаттары, аурулары, бөгде денелері және шұғыл жәрдем
• Функционалдық эндоскопиялық риносинусохирургия
• Әскери-дәрігерлік (дәрігерлік-ұшу) сараптамасы
• Балалар мен ересектерге шұғыл жәрдем көрсету тактикасы
• Жедел және шұғыл медициналық жәрдем`
    },
        work: {
    ru: `• 1991 — 2003 — Первая городская больница с поликлиникой
• 2003 — 2008 — Авиационная медицина МО РК
• 2003 — 2013 — Главный клинический госпиталь с поликлиникой МО РК
• 2007 — 2018 — Центральная военно-врачебная комиссия
• 2013 — 2015 — Республиканская школа «Жас Улан» МО РК
• 2015 — 2018 — Поликлиника КНБ
• 2019 — 2024 — Поликлиника "Достық"
• 2022 — по настоящее время — ГККП "СПОРТИВНЫЙ МЕДИЦИНСКИЙ ЦЕНТР ГОРОДА АСТАНЫ"`,
    kz: `• 1991 — 2003 — Емханасы бар бірінші қалалық аурухана
• 2003 — 2008 — ҚР ҚМ авиациялық медицинасы
• 2003 — 2013 — ҚР ҚМ емханасы бар бас клиникалық госпиталі
• 2007 — 2018 — Орталық әскери-дәрігерлік комиссиясы
• 2013 — 2015 — ҚР ҚМ «Жас Ұлан» республикалық мектебі
• 2015 — 2018 — ҰҚК емханасы
• 2019 — 2024 — «Достық» емханасы
• 2022 — қазіргі уақытқа дейін — Астана қаласының "Спорттық медицина орталығы" МКҚК`
  },
certificates: {
    ru: '',
    kz: '',
  }
  };
